import { render, staticRenderFns } from "./AutomaticView.vue?vue&type=template&id=5066510a&scoped=true&"
import script from "./AutomaticView.vue?vue&type=script&lang=ts&"
export * from "./AutomaticView.vue?vue&type=script&lang=ts&"
import style0 from "./AutomaticView.vue?vue&type=style&index=0&id=5066510a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066510a",
  null
  
)

export default component.exports